import axios from "axios";

// Add a request interceptor
axios.interceptors.request.use(
   config => {
      const token = localStorage.getItem('token')
      if (token) {
         config.headers['Authorization'] = 'Bearer ' + token
      }
      return config
   },
   error => {
      console.log('error: ', error);
      Promise.reject(error)
   }
)

// Add a response interceptor
axios.interceptors.response.use(
   res => res,
   error => {
      console.log('error: ', error);
      if (error.response.status === 401) {
         return Promise.reject(error)
      }
      return Promise.reject(error)
   }

)


const axiosALiv = axios.create();
axiosALiv.interceptors.request.use((config) => {
   const aliv_token = localStorage.getItem('aliv_token')
   if (aliv_token) {
      config.headers['Authorization'] = 'Bearer ' + aliv_token
   }
   return config;
});




export { axios, axiosALiv };